<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'company.overview.header' | translate }}" [menuService]="companyMenuService">
        <app-import-launcher class="buttons" />
    </app-header>

    <div *ngIf="company" class="profile-layout">
        <app-profile-card class="profile-layout-sidebar" [model]="company"></app-profile-card>
        <div class="profile-layout-content">
            @if (isKYBVisible()) {
                <ui-card class="profile-card" role="group" aria-labelledby="kyc-kyb-header" [withMargin]="false">
                    <app-kyc-kyb-status scope="KYB" />
                </ui-card>
            }
            <!-- Company Information -->
            <ui-card class="profile-card" [withMargin]="false">
                <div class="profile-card-header">
                    <h2>{{ 'company.overview.companyInfoHeader' | translate }}</h2>
                    <ui-button
                        type="link"
                        (click)="currentlyOpenDialog = 'COMPANY_INFO'"
                        *permission="editPermission"
                        >{{ 'edit' | translate }}</ui-button
                    >
                </div>
                <label>{{ 'company.overview.companyNameLabel' | translate }}</label>
                <div>{{ company.name }}</div>
                <label>{{ 'company.overview.dateFoundedLabel' | translate }}</label>
                <div>{{ company.incorporationDate | appDate: 'longDate' }}</div>
                <label>{{ 'company.overview.adminEmailLabel' | translate }}</label>
                <a href="mailto:{{ company.notification_email }}">{{ company.notification_email }}</a>
                <label>{{ 'company.overview.primaryPhoneLabel' | translate }}</label>
                <div>{{ company.phonePrimary }}</div>
                <label>{{ 'company.overview.faxLabel' | translate }}</label>
                <div>{{ company.fax }}</div>
                <label>{{ 'company.overview.websiteLabel' | translate }}</label>
                <div>
                    <a *ngIf="company.websiteAbsoluteUrl" href="{{ company.websiteAbsoluteUrl }}">
                        {{ company.websiteAbsoluteUrl }}
                    </a>
                </div>
                <label>{{ 'company.overview.industryLabel' | translate }}</label>
                <div>{{ company.industry }}</div>
            </ui-card>

            <ng-container *permission="payrollPermission">
                <!-- Payroll Information -->
                <ui-card class="profile-card" [withMargin]="false">
                    <div class="profile-card-header">
                        <h2>{{ 'company.overview.payrollInfoCraHeader' | translate }}</h2>
                        <ui-button type="link" (click)="currentlyOpenDialog = 'PAYROLL_INFO'">{{
                            'edit' | translate
                        }}</ui-button>
                    </div>
                    <label>{{ 'company.overview.craBusinessNumberLabel' | translate }}</label>
                    <div>{{ company.craBusinessNumber }}</div>
                    <label>{{ 'company.overview.craProgramCodeLabel' | translate }}</label>
                    <div>{{ company.craProgramCode }}</div>
                    <label>{{ 'company.overview.craReferenceNumberLabel' | translate }}</label>
                    <div>{{ company.craReferenceNumber }}</div>
                    <label>{{ 'company.overview.remitterTypeLabel' | translate }}</label>
                    <div>{{ company.remitterTypeDisplay | translate }}</div>
                </ui-card>

                <!-- QC Information -->
                <ui-card class="profile-card" [withMargin]="false" *ngIf="hasQcPayrollFeature">
                    <div class="profile-card-header">
                        <h2>{{ 'company.overview.payrollInfoRqHeader' | translate }}</h2>
                        <ui-button type="link" (click)="currentlyOpenDialog = 'PAYROLL_RQ_INFO'">{{
                            'edit' | translate
                        }}</ui-button>
                    </div>
                    <ui-banner *ngIf="shouldShowRqPayrollBanner" variant="info">
                        <p [innerHTML]="'company.overview.beforeYouCanPayQcEmployees' | translate"></p>
                    </ui-banner>
                    <label>{{ 'company.overview.quebecEnterpriseNumberLabel' | translate }}</label>
                    <div>{{ company.quebecEnterpriseNumber || '-' }}</div>
                    <label>{{ 'company.overview.rqRegistrationLabel' | translate }}</label>
                    <div>{{ company.rqRegistration || '-' }}</div>
                    <label>{{ 'company.overview.rqProgramCodeLabel' | translate }}</label>
                    <div>{{ company.rqProgramCode || '-' }}</div>
                    <label>{{ 'company.overview.rqReferenceNumberLabel' | translate }}</label>
                    <div>{{ company.rqReferenceNumber || '-' }}</div>
                    <label>{{ 'company.overview.rqRemittanceFrequencyLabel' | translate }}</label>
                    <div>{{ company.rqRemittanceFrequencyDisplay || '-' | translate }}</div>
                </ui-card>

                <!-- Bank info -->
                @if (company.isFlinksEnabled) {
                    <app-flinks-bank-account
                        [companyId]="company.id"
                        [bankAccount]="company.bankAccount"
                        [isPayrollSyncEnabled]="company.isPayrollSyncEnabled"
                    />
                } @else {
                    <ui-card class="profile-card" [withMargin]="false">
                        <div class="profile-card-header">
                            <h2>{{ 'company.overview.bankAccountHeader' | translate }}</h2>
                            <ui-button
                                *ngIf="!company.isPayrollSyncEnabled"
                                type="link"
                                (click)="currentlyOpenDialog = 'BANK_INFO'"
                                >{{ 'edit' | translate }}</ui-button
                            >
                        </div>
                        <label>{{ 'company.overview.bankInstitutionLabel' | translate }}</label>
                        <div>{{ company.bankAccount.institutionNumber }}</div>
                        <label>{{ 'company.overview.bankBranchLabel' | translate }}</label>
                        <div>{{ company.bankAccount.branchNumber }}</div>
                        <label>{{ 'company.overview.bankAccountLabel' | translate }}</label>
                        <div>{{ company.bankAccount.accountNumber }}</div>
                    </ui-card>
                }
            </ng-container>
        </div>
    </div>
</div>

<ui-dialog
    [open]="currentlyOpenDialog === 'COMPANY_INFO'"
    [form]="companyForm.form"
    (primaryButtonPressed)="submitForm(companyForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    [stickyHeader]="true"
    [stickyButtons]="true"
    secondaryButtonLabel="cancel"
    header="edit"
>
    <app-company-form #companyForm [company]="company"></app-company-form>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'PAYROLL_INFO'"
    [form]="payrollForm.form"
    (primaryButtonPressed)="submitForm(payrollForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="company.overview.payrollInfoCraHeader"
    size="small"
>
    <app-company-payroll-form
        #payrollForm
        [company]="company"
        [authorizationsDocumentsHaveBeenSubmitted]="authorizationsDocumentsHaveBeenSubmitted"
        [lastPaidRecurringPayrollEndDate]="lastPaidRecurringPayrollEndDate"
    ></app-company-payroll-form>
    <div class="flex justify-start" *ngIf="authorizationsDocumentsHaveBeenSubmitted">
        {{ 'company.overview.updateCraNumberDialogMessage' | translate }}&nbsp;
        <a target="_blank" href="{{ '11156049605911' | i18nHelpCentre }}">
            {{ 'company.overview.contactSupport' | translate }}
        </a>
    </div>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'PAYROLL_RQ_INFO'"
    [form]="payrollRqForm.form"
    (primaryButtonPressed)="submitForm(payrollRqForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="company.overview.payrollInfoRqHeader"
    size="small"
>
    <app-company-payroll-rq-form
        #payrollRqForm
        [company]="company"
        [authorizationsDocumentsHaveBeenSubmitted]="authorizationsDocumentsHaveBeenSubmitted"
        [lastPaidRecurringPayrollEndDate]="lastPaidRecurringPayrollEndDate"
    ></app-company-payroll-rq-form
></ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'BANK_INFO'"
    [form]="formBankAccount.form"
    (primaryButtonPressed)="submitForm(formBankAccount)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="edit"
>
    <app-form-company-bank-account #formBankAccount [bankAccount]="bankAccount"></app-form-company-bank-account>
</ui-dialog>
